<div class="modal-overlay" *transloco="let t; prefix: 'compliance.library.assignModal'">
  <div class="modal-content">

    <div class="title">
      <label>{{ t('title', { compliance: compliance.complianceName, checklistSubType: compliance.checklistSubTypeLabel || compliance.checklistSubType }) }}</label>
    </div>

    <div class="contents-container">

      <!-- Asset picker dropdown -->
      <div>
        <label>{{ t('vehicleAccount') }}</label>
        <app-compliance-asset-picker
          [tree]="assetsTree"
          [assignedAssetIds]="assignedAssetIds"
          [labelTitle]="t('pickerLabel')"
          [isLoaded]="assetsLoaded"
          (selectionChanged)="onSelectionChanged($event)">
        </app-compliance-asset-picker>
      </div>

      <!-- Selected assets list -->
      @if(selectedAssets.length > 0) {
        <div>
          <label>{{ (selectedAssets.length === 1 ? t('assetSelectedOne', { count: selectedAssets.length }) : t('assetSelectedMany', { count: selectedAssets.length })) }}</label>
          @if(flatAssetsModalList.length > 0) {
            <div>
              <cdk-virtual-scroll-viewport itemSize="27" class="modal-viewport" [style.max-height.px]="250">
                <ng-container *cdkVirtualFor="let entry of flatAssetsModalList">
                  @if(entry.rowType === 'group') {
                    <div class="group-header">
                      <label>{{ entry.accountName }}</label>
                      <label>
                        <span>({{ entry.count }})</span>
                        <span (click)="toggleCollapse(entry.accountName); $event.stopPropagation()" class="collapse-arrow">
                          <i [ngClass]="entry.collapsed ? 'ph ph-caret-up' : 'ph ph-caret-down'"></i>
                        </span>
                      </label>
                    </div>
                  }
                  @if(entry.rowType === 'item') {
                    <div class="group-item">
                      {{ entry.name }}
                    </div>
                  }
                </ng-container>
              </cdk-virtual-scroll-viewport>
            </div>
          }
        </div>
      }

    </div>

    <div class="button-group form-group">
      <button type="button" class="cancel-btn" (click)="close()">{{ 'common.cancel' | transloco }}</button>
      <button type="submit" class="save-btn" (click)="assignAsync()" [disabled]="isAssignDisabled">
        @if(!isAssigning) {
          <span>{{ 'common.assign' | transloco }}</span>
        }
        @if(isAssigning) {
          <span class="spinner-border d-flex justify-content-center align-items-center"></span>
        }
      </button>
    </div>

  </div>
</div>